import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IOrganizationViewModel } from 'src/app/ViewModel/OrganizationModel';
import { RestApiService } from '../rest-api.service';

@Injectable()
export class OrganizationService {
  private getOrganizationListUrl = 'Organization/GetOrganizationList';
  private insertUpdateOrgUrl = 'Organization/InsertUpdateOrganizationList';

  constructor(private restAPIService: RestApiService) { }

  /**
   * Get org API
   * @param groupId 50
   */
  public getOrganizationList(groupId?: number) : Observable<IOrganizationViewModel[]> {
    let reqData = {
      'groupId': groupId,
    };
    return this.restAPIService.new_POST(this.getOrganizationListUrl, reqData);
  }

  /**
   * Insert and Update Organization Details
   * @param organization 
   */
  public insertUpdateOrganization(organization : IOrganizationViewModel):Observable<any>{
    return this.restAPIService.new_POST(this.insertUpdateOrgUrl,organization);
  }


}
